export enum CrmFeatures {
  HSFORM_APP_ACCESS = "HSFORM_APP_ACCESS",
  HSFORM_MANAGE_FORM = "HSFORM_MANAGE_FORM",
  HSFORM_MANAGE_QUESTION = "HSFORM_MANAGE_QUESTION",
  HSFORM_MANAGE_SYSTEM = "HSFORM_MANAGE_SYSTEM",
  HSFORM_MANAGE_WORDMARKS = "HSFORM_MANAGE_WORDMARKS",
  HSFORM_MANAGE_SUBMISSIONS = "HSFORM_MANAGE_SUBMISSIONS",
  HSFORM_DASHBOARD = "HSFORM_DASHBOARD"
}
